import { render, staticRenderFns } from "./FailureStatusEmailTab.vue?vue&type=template&id=3b74aeb7&scoped=true&"
import script from "./FailureStatusEmailTab.vue?vue&type=script&lang=js&"
export * from "./FailureStatusEmailTab.vue?vue&type=script&lang=js&"
import style0 from "./FailureStatusEmailTab.vue?vue&type=style&index=0&id=3b74aeb7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b74aeb7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VRow})
